import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useLocation } from "react-router-dom";
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Header from '../Element/Header'

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '} {new Date().getFullYear()} {' '}
            <Link color="inherit" href="https://www.jababeka.com/" target="_blank">
                Kawasan Industri Jababeka
        </Link>
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(25)
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    divider: {
        marginBottom: theme.spacing(10)
    },
    paragraf: {
        textAlign: "justify",
        lineHeight: 2
    }
}));

export default function SuccessConfirmPayment() {
    const classes = useStyles();
    const location = useLocation();

    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <div className={classes.paper}>
                <Header />
                {/* <Avatar alt="Job Fair Logo" src="/logo512.png" variant="square" className={classes.large} />
                <Typography component="h1" variant="h5">
                    KAWASAN INDUSTRI JABABEKA
                </Typography>
                <Typography variant="subtitle1">
                    PROUDLY PRESENT
                </Typography>
                <Typography component="h1" variant="h6">
                    VIRTUAL JOB FAIR 2021
                </Typography> */}
                <Divider variant="middle" className={classes.divider} />
                <Grid container>
                    <Grid item xs>
                        <Typography variant="body1" gutterBottom>
                            Hai, <b>{location.state.name}</b>
                        </Typography>
                    </Grid>
                    <Typography color="textPrimary" variant="body2" className={classes.paragraf} gutterBottom>
                        Terima kasih telah melakukan konfirmasi pembayaran. Bukti pembayaran kamu akan diverifikasi maksimal 3x24 jam.
                        Jika pembayaran kamu telah berhasil diverifikasi, kami akan mengirimkan email email konfirmasi dan Nomor Registrasi kamu.
                        Harap bersabar yaa…
                    </Typography>
                    <Typography color="textPrimary" variant="body2" className={classes.paragraf} gutterBottom>
                        Apabila ada kendala dalam konfirmasi pembayaran silahkan hubungi Customer Service kami melalui WA ke <b>0811-8444-595</b>.
                        Silahkan follow official social media kami di instagram @jababekalearningcenter untuk mengetahui informasi dan update terbaru untuk event <b>Virtual Job Fair & Scholarship Hunt 2021</b> by <b>Kawasan Industri Jababeka.</b>
                    </Typography>
                </Grid>
            </div>
            <Box mt={10} mb={5}>
                <Copyright />
            </Box>
        </Container>
    );
}